import React from 'react'

function OurBusinessPart1() {
  return (
    <div>
    <section class="bg-[#04347c] bg-cover bg-center ">
    <div class="grid max-w-screen-xl px-4 py-8 mx-auto lg:gap-8 xl:gap-0 lg:py-16 lg:grid-cols-12">
        <div class="mr-auto place-self-center lg:col-span-7">
            <h1 class="max-w-2xl mb-4 text-4xl font-extrabold tracking-tight leading-none md:text-5xl xl:text-6xl text-white">Our Business</h1>
            <p class="max-w-2xl mb-6 font-light text-white lg:mb-8 md:text-lg lg:text-xl">We import top-quality electronic home appliances from China and also India and distribute them across Sri Lanka, ensuring excellent service and customer satisfaction.</p>
            
            <a href="/Contact" class="inline-flex items-center justify-center px-5 py-3 text-base font-medium text-center  border border-gray-300 rounded-lg  focus:ring-4 focus:ring-gray-100 text-white ">
                Contact Us
            </a> 
        </div>
                      
    </div>
</section>
    </div>
  )
}

export default OurBusinessPart1